(function(){
  var THRESHOLD = 50000; /* Rs.500 in paise */
  var BARID = 'tyo-shipbar';
  var css =
  '.tyo-sb{margin:0 0 12px;padding:12px 14px;background:linear-gradient(135deg,#FFF4FA,#FFFBEE);border:1px solid #F3D9E8;border-radius:12px;font-family:"DM Sans",-apple-system,sans-serif;box-sizing:border-box}'+
  '.tyo-sb *{box-sizing:border-box}'+
  '.tyo-sb-msg{font-size:13px;line-height:1.4;color:#292323;margin:0 0 9px;text-align:center}'+
  '.tyo-sb-msg b{color:#C51985}'+
  '.tyo-sb-done{color:#0A7C4A}'+
  '.tyo-sb-done b{color:#0A7C4A}'+
  '.tyo-sb-track{height:8px;background:#F1E1D2;border-radius:99px;overflow:hidden}'+
  '.tyo-sb-fill{height:100%;background:linear-gradient(90deg,#C51985,#E23DA3);border-radius:99px;transition:width .4s ease}'+
  '.tyo-sb-done .tyo-sb-fill,.tyo-sb-track.done .tyo-sb-fill{background:linear-gradient(90deg,#00B060,#0A7C4A)}';

  function money(paise){ return '₹' + Math.ceil(paise/100); }

  function barHTML(cart){
    var total = (cart && cart.total_price) || 0;
    var rem = THRESHOLD - total;
    var pct = Math.max(4, Math.min(100, Math.round(total / THRESHOLD * 100)));
    if(rem <= 0){
      return '<div class="tyo-sb-msg tyo-sb-done">🎉 Congratulations! You’ve unlocked <b>FREE shipping</b></div>'+
             '<div class="tyo-sb-track done"><div class="tyo-sb-fill" style="width:100%"></div></div>';
    }
    return '<div class="tyo-sb-msg">Add <b>'+money(rem)+'</b> more and get <b>FREE shipping</b>!</div>'+
           '<div class="tyo-sb-track"><div class="tyo-sb-fill" style="width:'+pct+'%"></div></div>';
  }

  function ensureCSS(){
    if(document.getElementById('tyo-sb-css')) return;
    var s = document.createElement('style'); s.id='tyo-sb-css'; s.textContent=css;
    document.head.appendChild(s);
  }

  function targets(){
    /* Cart drawer only — never product-card add-to-cart forms. */
    var sels = ['cart-drawer','cart-drawer-component','#cart-drawer','.cart-drawer','.drawer--cart'];
    /* Cart page: only when actually on /cart, and only the exact cart form (not /cart/add). */
    if(/^\/cart(\/|$|\?)/.test(location.pathname)){
      sels = sels.concat(['#cart','.cart-page','form[action="/cart"]']);
    }
    var found = [];
    sels.forEach(function(sel){
      var nodes; try{ nodes = document.querySelectorAll(sel); }catch(e){ return; }
      Array.prototype.forEach.call(nodes, function(el){ if(found.indexOf(el)<0) found.push(el); });
    });
    /* keep only top-most containers to avoid duplicate bars in nested elements */
    return found.filter(function(el){
      for(var i=0;i<found.length;i++){ if(found[i]!==el && found[i].contains(el)) return false; }
      return true;
    });
  }

  function render(cart){
    ensureCSS();
    var html = barHTML(cart);
    targets().forEach(function(container){
      var existing = container.querySelector('#'+BARID);
      if(existing){ existing.innerHTML = html; return; }
      var div = document.createElement('div');
      div.id = BARID; div.innerHTML = html;
      container.insertBefore(div, container.firstChild);
    });
  }

  var pending=false;
  function refresh(){
    if(pending) return; pending=true;
    fetch('/cart.js',{headers:{'Accept':'application/json'}})
      .then(function(r){ return r.json(); })
      .then(function(c){ pending=false; render(c); })
      .catch(function(){ pending=false; });
  }

  /* refresh after any cart mutation (add / change / update / clear) */
  var of = window.fetch;
  if(of){
    window.fetch = function(){
      var args = arguments;
      return of.apply(this, args).then(function(res){
        try{
          var u = (args[0] && args[0].url) || args[0] || '';
          if(typeof u === 'string' && /\/cart\/(add|change|update|clear)/.test(u)){ setTimeout(refresh, 300); }
        }catch(e){}
        return res;
      });
    };
  }

  var t=null;
  function debouncedRefresh(){ clearTimeout(t); t=setTimeout(refresh, 350); }
  document.addEventListener('click', debouncedRefresh, true);
  document.addEventListener('DOMContentLoaded', refresh);
  if(document.readyState !== 'loading') refresh();
})();
